import React, { useState, useEffect } from "react"
import S from "./AddToCart.module.scss"
import { connect } from "react-redux"
import { dbUserSavedList } from "../../database/dbreferences"
import { startSavedList } from "../../actions/savedList"

const SaveForLater = ({
  uid,
  id,
  image,
  name,
  price,
  sizes,
  startSavedList,
  savedList,
}) => {
  const [productInSaved, productInSavedUpdater] = useState(null)

  useEffect(() => {
    // if savedList is undefined then action a fetch from database
    if (uid && savedList === undefined) {
      startSavedList(uid)
    }
    // filters out the saved for later basket to find if the product exists in there
    // if the filter returns a an empty array of 0
    // then update the state of the button
    if (savedList) {
      savedList.filter(product => {
        if (id === product.id) {
          return product
        }
      }).length === 0
        ? productInSavedUpdater(false)
        : productInSavedUpdater(true)
    }
  }, [uid, savedList])

  return (
    <button
      style={{ opacity: productInSaved ? "0.5" : "1" }}
      className={`${S.addtocart} ${S.saveforlater}`}
      disabled={productInSaved ? true : false}
      onClick={() => {
        dbUserSavedList(uid).push({
          id,
          image,
          name,
          price,
          sizes,
        })
      }}
    >
      {!productInSaved ? "Save For Later" : "Saved For Later"}
    </button>
  )
}

// map state to props functions
const mapStateToProps = state => {
  return {
    uid: state.auth.uid,
    savedList: state.savedList.savedProducts,
  }
}

const mapDispatchToProps = dispatch => ({
  startSavedList: uid => {
    dispatch(startSavedList(uid))
  },
})

// calls to connect
export default connect(mapStateToProps, mapDispatchToProps)(SaveForLater)
